import React from 'react'
import { withAsync } from '@/components/Async'
import type { RouteConfig } from 'react-router-config'
import { Redirect } from 'react-router'
import Blank from '@/layouts/Blank'
import { withAddressSplitAlgorithmTrackPage } from '@/bizComponents/AddressAutoSplit/AddressSplitAlgorithmTrack'

const routes: RouteConfig[] = [
  {
    path: '/order',
    name: 'order',
    component: Blank,
    permissionCode: 'ship:order',
    routes: [
      {
        name: 'orderList',
        path: '/list',
        component: withAsync(() => import(/* webpackChunkName: "orderList" */ '@/containers/Order/List')),
        exact: true,
        main: true,
      },
      {
        name: 'create',
        path: '/create',
        menuTitle: 'order.create.order',
        component: withAddressSplitAlgorithmTrackPage(
          withAsync(() => import(/* webpackChunkName: "createOrder" */ '@/containers/Order/Create')),
          'orderCreate'
        ),
      },
      {
        name: 'edit',
        path: '/edit',
        menuTitle: 'order.edit.titile',
        component: withAddressSplitAlgorithmTrackPage(
          withAsync(() => import(/* webpackChunkName: "editOrder" */ '@/containers/Order/Edit')),
          'orderEdit'
        ),
      },
      {
        name: 'edit',
        path: '/ship',
        menuTitle: 'dashboard.teaching.step2title',
        component: withAddressSplitAlgorithmTrackPage(
          withAsync(() => import(/* webpackChunkName: "shipOrder" */ '@/containers/Order/Ship')),
          'orderShip'
        ),
      },
      {
        name: 'detail',
        path: '/detail/:id',
        component: withAsync(() => import(/* webpackChunkName: "orderDetail" */ '@/containers/Order/Detail')),
        exact: true,
      },
      {
        path: '/',
        component() {
          return <Redirect to="/ship/order/list" />
        },
        exact: true,
      },
    ],
  },
]

export default routes
